import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Row, Col, Card, CardBody, Container, Form, FormGroup, Input } from "reactstrap";
import moment from "moment";
import Select, { components } from "react-select";
import { Link } from "react-router-dom";

import DateRangePickerPrimary from "../../../share-components/ui/DateRangePickerPrimary";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import Breadcrumb from "../../../layout/breadcrumb";
import DiscountTotalSummary from "./components/DiscountTotalSummary";

import withReducer from "../../../store/withReducer";
import reportReducer from "../index";

import {
    getFinancesSummarySetting,
    getFinancesDiscountsDetails,
    exportFinancesDiscountsDetails
} from "./store/financesSummarySlice";
import { getGojungoSettings } from "../../manage-order/store/orderSlice";

import {
    formatter, formatterDecimal
} from "../../../utils/common";

import "./styles.scss";

const DiscountsDetails = (props) => {

    const financesSummaryState = useSelector(
        ({ report }) => report.financesSummary
    );

    const dispatch = useDispatch();
    const queryParams = new URLSearchParams(window.location.search);


    const [dateWiseReturn, setDateWiseReturn] = useState(queryParams.get('is_date_wise_return') == 1);
    const endDateObj = new Date(queryParams.get('end_date'));
    const startDateObj = new Date(queryParams.get('start_date')); // Create a new Date object from endDateObj
    // startDateObj.setDate(endDateObj.getDate() - 30); // Subtract 30 days from today

    const [dateRange, setDateRange] = useState([startDateObj, endDateObj]);
    const [startDate, endDate] = dateRange;


    const afterToday = () => {
        return (date) => date.getTime() > new Date().getTime();
    };

    // const startDate = queryParams.get('start_date');
    // const endDate = queryParams.get('end_date');
    const partner = queryParams.get('partner');
    const channel = queryParams.get('channel');
    const defaultPartner = partner ? { 'id':  Number(partner), 'name': '' } : null;

    const [loading, setLoading] = useState(true);
    const [exportBtnDisabled, setExportBtnDisabled] = useState(false);

    const [timer, setTimer] = useState(null);
    const [lastFillters, setLastFillters] = useState(null);
    const [fillterPartner, setFillterPartner] = useState(defaultPartner);
    const [fillterStatus, setFillterStatus] = useState({ 'id': 0, 'name': 'Normal Orders' });
    const [fillterCountryType, setFillterCountryType] = useState(null);
    const [fillterCurrency, setFillterCurrency] = useState(null);
    const [gojungoChannels, setGojungoChannels] = useState([]);
    const [fillterChannel, setFillterChannel] = useState(null);
    const [filter, setFilter] = useState({
        page: 1,
        pageSize: 10,
        start_date: moment(startDate).format("YYYY-MM-DD"),
        end_date: moment(endDate).format("YYYY-MM-DD"),
        partner: partner ? Number(partner) : null,
        country_type: fillterCountryType ? fillterCountryType.id : null,
        presentment_currency: fillterCurrency ? fillterCurrency.id : null,
        channel: channel || null,
        is_test_order: fillterStatus ? fillterStatus.id : null,
        is_date_wise_return: dateWiseReturn ? 1 : 0
    });

    const dataMenu = [
        {
            type: 1,
            text: "Finances Summary",
            link: '/report/finances-summary'
        },
        {
            type: 0,
            text: "Discount Details",
        },
    ];


    useEffect(() => {
        dispatch(getFinancesSummarySetting());
    }, [dispatch]);

    const getFinancesDetailsData = () => {
        if (JSON.stringify(filter) == JSON.stringify(lastFillters)) return;

        setLastFillters({ ...filter });
        setLoading(true);

        dispatch(
            getFinancesDiscountsDetails(filter)
        ).then((res) => {
            if (!res.error) {
                setLoading(false);
            }
        });
    };

    useEffect(() => {
        getFinancesDetailsData();
    }, [dispatch, filter]);
    

    useEffect(() => {
        if (financesSummaryState.settings.partners.length > 0 && partner != null && partner.length > 0) {
            const _partner = financesSummaryState.settings.partners.find(item => item.id == partner);
            setFillterPartner(_partner);
        }
    }, [financesSummaryState.settings.partners]);


    const tableColumns = [
        {
            name: 'Order Name',
            selector: (row) => {
                if (row.partner_id === 23) return row.order_name || 'N/A';
                if (row.partner_id === 20) return <Link className="text-primary" style={{ cursor: "pointer" }} to={`${process.env.PUBLIC_URL}/order/gojungo-orders/${row.order_id}`} target="_blank">{row.order_name || 'N/A'}</Link>;
                const btntext = (
                    <Link className="text-primary" style={{ cursor: "pointer" }} to={`${process.env.PUBLIC_URL}/order/${row.order_id}/view`} target="_blank">{row.order_name}</Link>
                );
                return btntext;
            },
            left: true,
            grow: 0.3, // column size
        }, 
        {
            name: 'Date',
            selector: row => row.processed_at,
            left: true,
            grow: 0.5, // column size
        },
        {
            name: 'SKU',
            selector: row => row.sku || 'N/A',
            left: true,
            grow: 0.7, // Larger column
            wrap: true, // Allow text wrapping
        },
        {
            name: 'Product',
            selector: row => row.product_name || 'N/A',
            left: true,
            wrap: true, // Allow text wrapping
        },
        {
            name: 'Country Code',
            selector: row => row.country_code,
            center: true,
            grow: 0.3, // column size
        },
        {
            name: 'Gross Discount',
            selector: row => formatter.format(row.discount_without_tax),
            right: true,
            grow: 0.3, // column size
        },
        {
            name: 'Tax',
            selector: row => formatterDecimal.format(row.tax_percentage) + '%',
            right: true,
            grow: 0.3, // column size
        },
        {
            name: 'Net Discount',
            selector: row => formatter.format(row.discount),
            right: true,
            grow: 0.3, // column size
        },
    ];

    const onPageSizeChange = (newPageSize) => {
        setFilter(prev => ({
            ...prev,
            page: 1,
            pageSize: newPageSize === 'All' ? financesSummaryState.discountDetailsTableRow : newPageSize
        }));
    }

    const onPageChange = (e) => {
        setFilter({ ...filter, page: e })
    }

    const handleCheckboxChangeForDateWiseReturn = () => {
        let isDateWise = !dateWiseReturn;
        setDateWiseReturn(isDateWise);
        setFilter(prev => ({
            ...prev,
            page: 1,
            is_date_wise_return: isDateWise ? 1 : 0
        }));
    };

    const handleOnChangeSKU = (e) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setFilter(prev => ({
                ...prev,
                page: 1,
                sku: e.target.value
            }));
        }, 500);
        setTimer(newTimer)
    };

    const handleOnChangeOrderNo = (e) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setFilter(prev => ({
                ...prev,
                page: 1,
                order_no: e.target.value
            }));
        }, 500);
        setTimer(newTimer)
    };

    useEffect(() => {
        if (fillterPartner?.id === 20) {
            if (gojungoChannels.length === 0) {
                dispatch(getGojungoSettings()).then((res) => {
                    const channels = res.payload?.channels || [];
                    setGojungoChannels(channels);
                    if (channel) {
                        const _channel = channels.find(item => item.id === channel);
                        if (_channel) setFillterChannel(_channel);
                    }
                });
            }
        } else {
            setFillterChannel(null);
        }
    }, [fillterPartner]);

    useEffect(() => {
        setFilter(prev => ({
            ...prev,
            start_date: moment(startDate).format("YYYY-MM-DD"),
            end_date: moment(endDate).format("YYYY-MM-DD"),
            partner: fillterPartner ? fillterPartner.id : null,
            country_type: fillterCountryType ? fillterCountryType.id : null,
            presentment_currency: fillterCurrency ? fillterCurrency.id : null,
            channel: fillterPartner?.id === 20 && fillterChannel ? fillterChannel.id : null,
            is_test_order: fillterStatus ? fillterStatus.id : null,
            is_date_wise_return: dateWiseReturn ? 1 : 0
        }));
    }, [startDate, endDate, dateWiseReturn, fillterPartner, fillterStatus, fillterCurrency, fillterCountryType, fillterChannel])

    const exportFile = () => {
        if (exportBtnDisabled) return;
        setExportBtnDisabled(true);

        dispatch(
            exportFinancesDiscountsDetails(filter)
        ).then((res) => {
            const link = document.createElement("a");
            link.href = res.payload;
            link.setAttribute("download", "");
            document.body.appendChild(link);
            link.click();
            link.remove();
            setExportBtnDisabled(false);
        });
    };

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: 50,
            border: "none",
        }),
    };

    const statuses = [
        { 'id': 0, 'name': 'Normal Orders' },
        { 'id': 1, 'name': 'Test Orders' },
    ];

    const countryTypes = [
        { 'id': 'uk', 'name': 'UK' },
        { 'id': 'europe', 'name': 'Europe' },
        { 'id': 'international', 'name': 'International' },
    ];

    return (
        <Fragment>
            <Breadcrumb title="Discount Details" data={dataMenu} />
            <Container fluid={true} className="finances-summary-page feature-products">
                <Card className="px-3">
                    <Row>
                        <Col md="4">
                            <div className="p-3">
                                <DateRangePickerPrimary
                                    dateRange={dateRange}
                                    dateRangeChange={(date) => {
                                        setDateRange(date);
                                    }}
                                    defaultValue={[endDateObj, startDateObj]}
                                    disabledDate={afterToday()}
                                />
                            </div>
                        </Col>
                        <Col>
                            <div className="float-left">
                                <div className="checkbox checkbox-primary mt-4 mb-3">
                                    <input
                                        id="financesSummaryReturnCalc"
                                        type="checkbox"
                                        checked={dateWiseReturn}
                                        onChange={handleCheckboxChangeForDateWiseReturn}
                                    />
                                    <label htmlFor="financesSummaryReturnCalc">Calculating Date-Wise Returns for Current Date</label>
                                </div>
                            </div>

                            <div className="float-right">
                                <Button
                                    type="button"
                                    color="primary"
                                    className="mt-3"
                                    onClick={() => {
                                        exportFile();
                                    }}
                                    disabled={exportBtnDisabled}
                                >
                                    <i className={exportBtnDisabled ? "fa fa-spinner fa-spin mr-1" : "fa fa-download mr-1"}></i>
                                    Export Report
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Card>

                <Row>
                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Partner"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={fillterPartner}
                            onChange={(e) => {
                                setFillterPartner(e);
                            }}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterPartner ? null : <components.DropdownIndicator {...props} />;
                                }
                            }}
                            isClearable={true}
                            options={financesSummaryState.settings.partners}
                        />
                    </Col>

                    {fillterPartner?.id === 20 && (
                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Channel"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={fillterChannel}
                            onChange={(e) => {
                                setFillterChannel(e);
                            }}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterChannel ? null : <components.DropdownIndicator {...props} />;
                                }
                            }}
                            isClearable={true}
                            options={gojungoChannels}
                        />
                    </Col>
                    )}

                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Status"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={fillterStatus}
                            onChange={(e) => {
                                setFillterStatus(e);
                            }}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterStatus ? null : <components.DropdownIndicator {...props} />;
                                }
                            }}
                            isClearable={true}
                            options={statuses}
                        />
                    </Col>

                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Country Type"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={fillterCountryType}
                            onChange={(e) => {
                                setFillterCountryType(e);
                            }}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterCountryType ? null : <components.DropdownIndicator {...props} />;
                                }
                            }}
                            isClearable={true}
                            options={countryTypes}
                        />
                    </Col>

                    <Col md="">
                        <Select
                            className="select2-filter"
                            styles={customStyles}
                            placeholder="Fillter by Currency"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={fillterCurrency}
                            onChange={(e) => {
                                setFillterCurrency(e);
                            }}
                            components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: (props) => {
                                    return fillterCurrency ? null : <components.DropdownIndicator {...props} />;
                                }
                            }}
                            isClearable={true}
                            options={financesSummaryState.settings.currencies}
                        />
                    </Col>

                    <Col md="">
                        <Form>
                            <FormGroup className="m-0">
                                <Input
                                    className="form-control"
                                    type="text"
                                    placeholder="Fillter by SKU"
                                    onChange={handleOnChangeSKU}
                                />
                                <i className="fa fa-search"></i>
                            </FormGroup>
                        </Form>
                    </Col>

                    <Col md="">
                        <Form>
                            <FormGroup className="m-0">
                                <Input
                                    className="form-control"
                                    type="text"
                                    placeholder="Fillter by Order No"
                                    onChange={handleOnChangeOrderNo}
                                />
                                <i className="fa fa-search"></i>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>


                <DiscountTotalSummary financesSummaryState={financesSummaryState} />

                <Card className="px-3">
                    <CardBody>
                        <div className="table-responsive product-table">
                            <CommonDataTable
                                headerColumns={tableColumns}
                                gridData={financesSummaryState.discountDetailsLists}
                                noAction
                                progressPending={loading}
                                paginationServer
                                paginationTotalRows={financesSummaryState.discountDetailsTableRow}
                                paginationRowsPerPageOptions={[10, 50, 100, 500, 1000]}
                                paginationDefaultPage={filter.page}
                                paginationPerPage={filter.pageSize}
                                onChangePage={onPageChange}
                                onChangeRowsPerPage={onPageSizeChange}
                            />
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    );
}

export default withReducer([{ report: reportReducer }])(DiscountsDetails);